import axios from 'axios';
import Notification from '../notification/notification-es';
import {input} from "../input/input";

const popup = Notification({
    position: 'top-right',
    duration: 2000,
    isHidePrev: false,
    isHideTitle: true,
    maxOpened: 3,
});

const dataPrefix = 'data-form-contact';
const classPrefix = 'form-contact';
const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    formContact();
}

export function formContact() {
    const $form = $container.querySelector(`[${dataPrefix}-form]`);
    const $submit = $container.querySelector(`[${dataPrefix}-submit]`);
    if (!$form || !$submit) return;

    // Сохраним и удалим кнопку, чтобы вставить поля перед ней
    $submit.remove();

    const inputsConfig = [
        { type: 'text', label: 'Iм\'я', name: 'name', required: true, autocomplete: 'name', half: true },
        { type: 'email', label: 'Email', name: 'email', required: true, autocomplete: 'email', half: true },
        { type: 'tel', label: 'Телефон', name: 'phone', required: true, autocomplete: 'tel',
            pattern: '\\+?[0-9]{7,15}', title: 'Номер: 7–15 цифр, необов\'язково з +' , half: false },
        { type: 'textarea', label: 'Коментар', name: 'comment', required: true, autocomplete: 'off', rows: 4, half: false },
    ];

    // Вставка полей
    inputsConfig.forEach(cfg => {
        // Передаем контейнер для input
        input($form, {
            type: cfg.type,
            label: cfg.label,
            name: cfg.name,
            value: '',
            autocomplete: cfg.autocomplete || '',
            required: cfg.required,
            rows: cfg.rows || undefined,
        });
        // После создания проставляем pattern/title и помечаем wrapper классом
        const $inp = $form.querySelector(`[name="${cfg.name}"]`);
        if ($inp) {
            if (cfg.pattern) {
                $inp.setAttribute('pattern', cfg.pattern);
                if (cfg.title) $inp.setAttribute('title', cfg.title);
            }
            // Обёртка — ближайший [data-input-form]
            const $wrapper = $inp.closest(`[data-input-form]`);
            if ($wrapper) {
                if (cfg.half) {
                    $wrapper.classList.add(`${classPrefix}__field--half`);
                } else {
                    $wrapper.classList.add(`${classPrefix}__field--full`);
                }
            }
        }
    });

    // Вернём кнопку в конец формы
    $form.appendChild($submit);

    // Обработчик submit
    $form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!$form.checkValidity()) {
            $form.reportValidity();
            return;
        }
        const data = {};
        inputsConfig.forEach(cfg => {
            const $i = $form.querySelector(`[name="${cfg.name}"]`);
            data[cfg.name] = $i ? $i.value.trim() : '';
        });
        try {
            $submit.disabled = true;
            const response = await axios.post('/api/support', data);
            popup.success({ message: response.data.message || 'Успішно відправлено!' });
            // очистка
            inputsConfig.forEach(cfg => {
                const $i = $form.querySelector(`[name="${cfg.name}"]`);
                if ($i) {
                    $i.value = '';
                    const $w = $i.closest(`[data-input-form]`);
                    if ($w) $w.classList.remove('active');
                }
            });
        } catch (err) {
            console.error(err);
            const msg = err.response?.data?.message || 'Не вдалося відправити. Спробуйте ще раз';
            popup.error({ message: msg });
        } finally {
            $submit.disabled = false;
        }
    });
}
